import React, { FC } from 'react';
import s from './collectionWeekCard.module.scss';
import { CdnPath } from '@specs/cdn';
import { Button } from '@components/UIKit/Button/Button';
import { useTranslation } from '@hooks/useTranslation';
import { useGetCollectionOfTheWeek } from '@services/collection/hooks/useGetCollectionOfTheWeek';
import { useRouter } from 'next/router';
import { LinksEnum } from '@specs/navigation';
import cn from 'classnames';
import { OptimizedImage } from '@components/OptimizedImage/OptimizedImage';
type CollectionWeekCardProps = {
  className?: string;
};
export const CollectionWeekCard: FC<CollectionWeekCardProps> = ({
  className
}) => {
  const {
    data
  } = useGetCollectionOfTheWeek();
  const {
    translate: tr
  } = useTranslation();
  const router = useRouter();
  if (!data) return null;
  return <div className={cn(s.collectionWeekCard, className)} data-sentry-component="CollectionWeekCard" data-sentry-source-file="CollectionWeekCard.tsx">
            <OptimizedImage path={CdnPath.collectionMeta} alt={'Collection of the week'} boxClassName={s.collectionWeekCard__image} cdnId={data.imageid} fill style={{
      objectFit: 'cover',
      objectPosition: 'center'
    }} data-sentry-element="OptimizedImage" data-sentry-source-file="CollectionWeekCard.tsx" />
            <div className={s.collectionWeekCard__background} />
            <div className={s.collectionWeekCard__info}>
                <h4 className={s.collectionWeekCard__name}>{data.name}</h4>
                <Button id='explore_collection_button' onClick={async () => await router.push({
        pathname: LinksEnum.EXPLORE_COLLECTION,
        query: {
          slug: data.id
        }
      })} size='large' color='Zhen Zhu Bai Pearl' data-sentry-element="Button" data-sentry-source-file="CollectionWeekCard.tsx">
                    {tr({
          id: 'btn.explore'
        })}
                </Button>
            </div>

        </div>;
};